import React from "react";
import Reactshare from "./Reactshare";
import "../../styles/NavBar.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white border-top mt-5">
      <div className="container py-5">
        <div className="row px-0">
          {/* Left Column */}
          <div className="col-md-6 mb-4 mb-md-0 ps-md-0">
            <Link to="/" className="logo mb-4 d-inline-block">
              <img src="assets/images/wiselogo.svg" alt="WISE Logo" />
            </Link>
            <p
              className="text-primary small mb-4"
              style={{ maxWidth: "300px" }}
            >
              Wise empowers teams to transform raw data into clear, compelling
              visuals — making insights easier to share, understand, and act on.
            </p>
            <Reactshare />
          </div>

          {/* Right Column */}
          <div className="col-md-6 pe-md-0">
            <div className="row">
              {/* Resources */}
              <div className="col-6">
                <h6 className="fw-bold mb-3">Resources</h6>
                <ul className="list-unstyled small">
                  <li>
                    <Link
                      to="/events"
                      className="text-decoration-none text-primary"
                    >
                      Events
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/blogs"
                      className="text-decoration-none text-primary"
                    >
                      Blogs
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/gallery"
                      className="text-decoration-none text-primary"
                    >
                      Gallery
                    </Link>
                  </li> */}
                </ul>
              </div>

              {/* Company */}
              <div className="col-4">
                <h6 className="fw-bold mb-3">Company</h6>
                <ul className="list-unstyled small">
                  <li>
                    <Link
                      to="/about"
                      className="text-decoration-none text-primary"
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contactUs"
                      className="text-decoration-none text-primary"
                    >
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="border-top pt-4 mt-4 d-flex flex-column flex-md-row justify-content-between align-items-center text-primary small">
          <p className="mb-2 mb-md-0">
            © {new Date().getFullYear()} Wise. All rights reserved – Site
            developed by{" "}
            <a
              href="https://springeveningpl.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none text-primary fw-bold"
            >
              Springevening Private Limited
            </a>
          </p>
          <div className="d-flex gap-4">
            <Link to="/privacy" className="text-decoration-none text-primary">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-decoration-none text-primary">
              Terms of Service
            </Link>
            <Link to="/cookies" className="text-decoration-none text-primary">
              Cookies Settings
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
